import React from 'react';

import styles from './Header.module.scss';
import print from '../../../assets/images/printer.svg';
const Header = () => {
  return (
    <div className={styles["container"]}>
      <div className={styles["text-section"]}>
        <div className={styles["title"]}>
          Required Minimum Distribution (RMD)
        </div>
        <div className={styles["sub-title"]}>
          T. Rowe Price can help you calculate, schedule, and even re-invest your Required Minimum Distribution (RMD) from your eligible IRA(s).
        </div>
      </div>
      <div className={styles["print-section"]}>
        <button className={styles["buttonBorder"]} onClick={() => window.print()}>
          <div className={styles["print-button"]}>
            Print
          </div>
            <img src={print} alt='' className={styles["printer-img"]}/>
        </button>
      </div>
    </div>
  );
};

export default Header;
